import { useEffect, useMemo, useState } from 'react'

export const DEFAULT_PAGE_SIZE = 20

export function useClientPagination<T>(
  rows: readonly T[],
  opts: { pageSize?: number; resetKey?: unknown } = {},
) {
  const pageSize = opts.pageSize ?? DEFAULT_PAGE_SIZE
  const [page, setPage] = useState(1)
  const total = rows.length
  const pageCount = Math.max(1, Math.ceil(total / pageSize))

  useEffect(() => {
    setPage(1)
  }, [opts.resetKey])

  useEffect(() => {
    setPage((current) => Math.min(current, pageCount))
  }, [pageCount])

  const visible = useMemo(
    () => rows.slice((page - 1) * pageSize, page * pageSize),
    [page, pageSize, rows],
  )

  return { rows: visible, page, setPage, pageCount, pageSize, total }
}
